import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "icon-plus",
  viewBox: "0 0 16 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.306",
      d: "M8 .072v7.143m0 1.713v7.142M0 7.965h7.142m1.715 0H16"
    }, null, -1)
  ]))]))
}
export default { render: render }